<div class="main-content pt-4 mt-0">
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-4 col-md-2" *ngFor="let card of resumenCards; index as i">
        <!-- [class]="i < 2 ? 'col-md-6' : 'col-md-4'" -->
        <div
          class="card card-stats"
          [ngClass]="{ 'card-stats__selected': i === 0 }"
          [routerLink]="card.route"
          [style.cursor]="card.route ? 'pointer' : 'default'"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-7 col-lg-6">
                <div
                  class="icon-big text-center text-dark rounded shadow"
                  [ngClass]="card.bgClass"
                >
                  <i [class]="card.icon"></i>
                </div>
              </div>
              <div class="col-7 d-flex flex-column justify-content-center">
                <p class="card-category mb-0">{{ card.label }}</p>
                <h4
                  class="card-title mb-0"
                  [ngClass]="{ 'text-dark': i === 0, 'text-white': i !== 0 }"
                >
                  {{ card.value }}
                </h4>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="stats">
              <small [class]="i == 0 ? 'desc__selected' : 'desc'">{{
                card.desc
              }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-10 mx-auto">
        <div class="card">
          <div class="card-header card-header-icon">
            <div class="card-icon">
              <i class="material-icons">tips_and_updates</i>
            </div>
            <h4 class="card-title">
              {{ isViewOnly ? "View" : "Update" }} Recommendation
            </h4>
          </div>
          <div class="card-body">
            <form [formGroup]="form">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="targetKeyword"
                      >Target Keyword</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="targetKeyword"
                      formControlName="targetKeyword"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="targetUrl"
                      >Target URL</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="targetUrl"
                      formControlName="targetUrl"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="city">City</label>
                    <input
                      type="text"
                      class="form-control"
                      id="city"
                      formControlName="city"
                    />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="service"
                      >Service</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="service"
                      formControlName="service"
                    />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="industry"
                      >Industry</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="industry"
                      formControlName="industry"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="landingType"
                      >Landing Type</label
                    >
                    <select
                      class="form-control"
                      id="landingType"
                      formControlName="landingType"
                    >
                      <option
                        *ngFor="let type of landingTypes"
                        [value]="type.value"
                      >
                        {{ type.label }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="recommendationType"
                      >Recommendation Type</label
                    >
                    <select
                      class="form-control"
                      id="recommendationType"
                      formControlName="recommendationType"
                    >
                      <option
                        *ngFor="let type of recommendationTypes"
                        [value]="type.value"
                      >
                        {{ type.label }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="priority"
                      >Priority</label
                    >
                    <select
                      class="form-control"
                      id="priority"
                      formControlName="priority"
                    >
                      <option *ngFor="let p of priorities" [value]="p.value">
                        {{ p.label }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="diagnosis"
                      >Diagnosis</label
                    >
                    <textarea
                      class="form-control"
                      id="diagnosis"
                      formControlName="diagnosis"
                      rows="3"
                    ></textarea>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="recommendation"
                      >Recommendation</label
                    >
                    <textarea
                      class="form-control"
                      id="recommendation"
                      formControlName="recommendation"
                      rows="3"
                    ></textarea>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="proposedChanges"
                      >Proposed Changes</label
                    >
                    <textarea
                      class="form-control"
                      id="proposedChanges"
                      formControlName="proposedChanges"
                      rows="3"
                    ></textarea>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="status"
                      >Status</label
                    >
                    <select
                      class="form-control"
                      id="status"
                      formControlName="status"
                    >
                      <option *ngFor="let s of statuses" [value]="s.value">
                        {{ s.label }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="source"
                      >Source</label
                    >
                    <select
                      class="form-control"
                      id="source"
                      formControlName="source"
                    >
                      <option *ngFor="let src of sources" [value]="src.value">
                        {{ src.label }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="row mt-4" *ngIf="id">
                <div class="col-md-12">
                  <label class="bmd-label-floating font-weight-bold" for="suggestedKeywords">Suggested Keywords</label>
                  <div class="row pt-2" formGroupName="suggestedKeywords">
                    <div class="col-md-4">
                      <h6>Corto Plazo</h6>
                      <div class="form-check" *ngFor="let opt of suggestedKeywordsOptions.shortTerm">
                        <label class="form-check-label">
                          <input class="form-check-input" type="checkbox" [value]="opt"
                                 [checked]="isChecked('suggestedKeywords', 'shortTerm', opt)"
                                 (change)="toggleCheckbox('suggestedKeywords', 'shortTerm', opt, $event)">
                          {{ opt }}
                          <span class="form-check-sign"><span class="check"></span></span>
                        </label>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <h6>Mediano Plazo</h6>
                      <div class="form-check" *ngFor="let opt of suggestedKeywordsOptions.mediumTerm">
                        <label class="form-check-label">
                          <input class="form-check-input" type="checkbox" [value]="opt"
                                 [checked]="isChecked('suggestedKeywords', 'mediumTerm', opt)"
                                 (change)="toggleCheckbox('suggestedKeywords', 'mediumTerm', opt, $event)">
                          {{ opt }}
                          <span class="form-check-sign"><span class="check"></span></span>
                        </label>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <h6>Largo Plazo</h6>
                      <div class="form-check" *ngFor="let opt of suggestedKeywordsOptions.longTerm">
                        <label class="form-check-label">
                          <input class="form-check-input" type="checkbox" [value]="opt"
                                 [checked]="isChecked('suggestedKeywords', 'longTerm', opt)"
                                 (change)="toggleCheckbox('suggestedKeywords', 'longTerm', opt, $event)">
                          {{ opt }}
                          <span class="form-check-sign"><span class="check"></span></span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mt-4" *ngIf="id">
                <div class="col-md-12">
                  <label class="bmd-label-floating font-weight-bold" for="suggestedAnchors">Suggested Anchors</label>
                  <div class="row pt-2" formGroupName="suggestedAnchors">
                    <div class="col-md-4">
                      <h6>Corto Plazo</h6>
                      <div class="form-check" *ngFor="let opt of suggestedAnchorsOptions.shortTerm">
                        <label class="form-check-label">
                          <input class="form-check-input" type="checkbox" [value]="opt"
                                 [checked]="isChecked('suggestedAnchors', 'shortTerm', opt)"
                                 (change)="toggleCheckbox('suggestedAnchors', 'shortTerm', opt, $event)">
                          {{ opt }}
                          <span class="form-check-sign"><span class="check"></span></span>
                        </label>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <h6>Mediano Plazo</h6>
                      <div class="form-check" *ngFor="let opt of suggestedAnchorsOptions.mediumTerm">
                        <label class="form-check-label">
                          <input class="form-check-input" type="checkbox" [value]="opt"
                                 [checked]="isChecked('suggestedAnchors', 'mediumTerm', opt)"
                                 (change)="toggleCheckbox('suggestedAnchors', 'mediumTerm', opt, $event)">
                          {{ opt }}
                          <span class="form-check-sign"><span class="check"></span></span>
                        </label>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <h6>Largo Plazo</h6>
                      <div class="form-check" *ngFor="let opt of suggestedAnchorsOptions.longTerm">
                        <label class="form-check-label">
                          <input class="form-check-input" type="checkbox" [value]="opt"
                                 [checked]="isChecked('suggestedAnchors', 'longTerm', opt)"
                                 (change)="toggleCheckbox('suggestedAnchors', 'longTerm', opt, $event)">
                          {{ opt }}
                          <span class="form-check-sign"><span class="check"></span></span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mt-4" *ngIf="id">
                <div class="col-md-12">
                  <label class="bmd-label-floating font-weight-bold" for="targetAnchors">Target Anchors</label>
                  <div class="row pt-2" formGroupName="targetAnchors">
                    <div class="col-md-4">
                      <h6>Corto Plazo</h6>
                      <div class="form-check" *ngFor="let opt of targetAnchorsOptions.shortTerm">
                        <label class="form-check-label">
                          <input class="form-check-input" type="checkbox" [value]="opt"
                                 [checked]="isChecked('targetAnchors', 'shortTerm', opt)"
                                 (change)="toggleCheckbox('targetAnchors', 'shortTerm', opt, $event)">
                          {{ opt }}
                          <span class="form-check-sign"><span class="check"></span></span>
                        </label>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <h6>Mediano Plazo</h6>
                      <div class="form-check" *ngFor="let opt of targetAnchorsOptions.mediumTerm">
                        <label class="form-check-label">
                          <input class="form-check-input" type="checkbox" [value]="opt"
                                 [checked]="isChecked('targetAnchors', 'mediumTerm', opt)"
                                 (change)="toggleCheckbox('targetAnchors', 'mediumTerm', opt, $event)">
                          {{ opt }}
                          <span class="form-check-sign"><span class="check"></span></span>
                        </label>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <h6>Largo Plazo</h6>
                      <div class="form-check" *ngFor="let opt of targetAnchorsOptions.longTerm">
                        <label class="form-check-label">
                          <input class="form-check-input" type="checkbox" [value]="opt"
                                 [checked]="isChecked('targetAnchors', 'longTerm', opt)"
                                 (change)="toggleCheckbox('targetAnchors', 'longTerm', opt, $event)">
                          {{ opt }}
                          <span class="form-check-sign"><span class="check"></span></span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mt-4" *ngIf="id">
                <div class="col-md-12">
                  <label class="bmd-label-floating font-weight-bold" for="targetLocations">Target Locations</label>
                  <div class="row pt-2" formGroupName="targetLocations">
                    <div class="col-md-4">
                      <h6>Corto Plazo</h6>
                      <div class="form-check" *ngFor="let opt of targetLocationsOptions.shortTerm">
                        <label class="form-check-label">
                          <input class="form-check-input" type="checkbox" [value]="opt"
                                 [checked]="isChecked('targetLocations', 'shortTerm', opt)"
                                 (change)="toggleCheckbox('targetLocations', 'shortTerm', opt, $event)">
                          {{ opt }}
                          <span class="form-check-sign"><span class="check"></span></span>
                        </label>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <h6>Mediano Plazo</h6>
                      <div class="form-check" *ngFor="let opt of targetLocationsOptions.mediumTerm">
                        <label class="form-check-label">
                          <input class="form-check-input" type="checkbox" [value]="opt"
                                 [checked]="isChecked('targetLocations', 'mediumTerm', opt)"
                                 (change)="toggleCheckbox('targetLocations', 'mediumTerm', opt, $event)">
                          {{ opt }}
                          <span class="form-check-sign"><span class="check"></span></span>
                        </label>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <h6>Largo Plazo</h6>
                      <div class="form-check" *ngFor="let opt of targetLocationsOptions.longTerm">
                        <label class="form-check-label">
                          <input class="form-check-input" type="checkbox" [value]="opt"
                                 [checked]="isChecked('targetLocations', 'longTerm', opt)"
                                 (change)="toggleCheckbox('targetLocations', 'longTerm', opt, $event)">
                          {{ opt }}
                          <span class="form-check-sign"><span class="check"></span></span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div class="row mt-4" *ngIf="id">
                <div class="col-md-12">
                  <label class="bmd-label-floating font-weight-bold" for="suggestedProspectTypes">Suggested Prospect Types</label>
                  <div class="row pt-2" formGroupName="suggestedProspectTypes">
                    <div class="col-md-4">
                      <h6>Corto Plazo</h6>
                      <div class="form-check" *ngFor="let opt of suggestedProspectTypesOptions.shortTerm">
                        <label class="form-check-label">
                          <input class="form-check-input" type="checkbox" [value]="opt"
                                 [checked]="isChecked('suggestedProspectTypes', 'shortTerm', opt)"
                                 (change)="toggleCheckbox('suggestedProspectTypes', 'shortTerm', opt, $event)">
                          {{ opt }}
                          <span class="form-check-sign"><span class="check"></span></span>
                        </label>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <h6>Mediano Plazo</h6>
                      <div class="form-check" *ngFor="let opt of suggestedProspectTypesOptions.mediumTerm">
                        <label class="form-check-label">
                          <input class="form-check-input" type="checkbox" [value]="opt"
                                 [checked]="isChecked('suggestedProspectTypes', 'mediumTerm', opt)"
                                 (change)="toggleCheckbox('suggestedProspectTypes', 'mediumTerm', opt, $event)">
                          {{ opt }}
                          <span class="form-check-sign"><span class="check"></span></span>
                        </label>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <h6>Largo Plazo</h6>
                      <div class="form-check" *ngFor="let opt of suggestedProspectTypesOptions.longTerm">
                        <label class="form-check-label">
                          <input class="form-check-input" type="checkbox" [value]="opt"
                                 [checked]="isChecked('suggestedProspectTypes', 'longTerm', opt)"
                                 (change)="toggleCheckbox('suggestedProspectTypes', 'longTerm', opt, $event)">
                          {{ opt }}
                          <span class="form-check-sign"><span class="check"></span></span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->

              <!-- <div class="row mt-4" *ngIf="id">
                <div class="col-md-12">
                  <label class="bmd-label-floating font-weight-bold" for="suggestedDomains">Suggested Domains</label>
                  <div class="row pt-2" formGroupName="suggestedDomains">
                    <div class="col-md-4">
                      <h6>Corto Plazo</h6>
                      <div class="form-check" *ngFor="let opt of suggestedDomainsOptions.shortTerm">
                        <label class="form-check-label">
                          <input class="form-check-input" type="checkbox" [value]="opt"
                                 [checked]="isChecked('suggestedDomains', 'shortTerm', opt)"
                                 (change)="toggleCheckbox('suggestedDomains', 'shortTerm', opt, $event)">
                          {{ opt }}
                          <span class="form-check-sign"><span class="check"></span></span>
                        </label>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <h6>Mediano Plazo</h6>
                      <div class="form-check" *ngFor="let opt of suggestedDomainsOptions.mediumTerm">
                        <label class="form-check-label">
                          <input class="form-check-input" type="checkbox" [value]="opt"
                                 [checked]="isChecked('suggestedDomains', 'mediumTerm', opt)"
                                 (change)="toggleCheckbox('suggestedDomains', 'mediumTerm', opt, $event)">
                          {{ opt }}
                          <span class="form-check-sign"><span class="check"></span></span>
                        </label>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <h6>Largo Plazo</h6>
                      <div class="form-check" *ngFor="let opt of suggestedDomainsOptions.longTerm">
                        <label class="form-check-label">
                          <input class="form-check-input" type="checkbox" [value]="opt"
                                 [checked]="isChecked('suggestedDomains', 'longTerm', opt)"
                                 (change)="toggleCheckbox('suggestedDomains', 'longTerm', opt, $event)">
                          {{ opt }}
                          <span class="form-check-sign"><span class="check"></span></span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->

              <div class="row mt-4">
                <div class="col-12 text-right">
                  <button
                    type="button"
                    class="btn btn-secondary mr-2"
                    (click)="goBack()"
                  >
                    Back
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
